<template>
    <div id="reset-device-battery-by-downlink-dialog-validation-component">
        <v-dialog v-model="is_reset_device_battery_by_downlink_dialog_open" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">
                        {{ $t('reset_battery') }}
                    </span>
                </v-card-title>
                <v-card-text class="pb-0">
                    <div class="text-skin-default">
                        {{ $t('confirm_reset_device_battery_downlink') }}
                    </div>
                    {{ $t('cannot_be_canceled') }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="is_reset_device_battery_by_downlink_dialog_open = false">{{ $t('global.cancel') }}</v-btn>
                    <v-btn
                        :loading="sending_device_battery_by_downlink"
                        color="primary"
                        elevation="0"
                        rounded
                        @click="sendDownlinkResetBattery"
                    >
                        <span class="white--text">{{ $t('global.validate') }}</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import downlinkRepository from '@/repositories/DownlinkRepository'

export default {
    name: 'ResetDeviceBatteryByDownlinkDialogValidationComponent',
    data() {
        return {
            device: {},
            is_reset_device_battery_by_downlink_dialog_open: false,
            sending_device_battery_by_downlink: false,
        }
    },
    methods: {
        sendDownlinkResetBattery() {
            this.sending_device_battery_by_downlink = true
            return downlinkRepository
                .sendDownlinkResetBattery(this.device.id_device)
                .then((success) => {
                    this.is_reset_device_battery_by_downlink_dialog_open = false
                    this.showSnackbar('success', this.$t('global.updated'))
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.sending_device_battery_by_downlink = false
                })
        },
        openResetDeviceBatteryByDownlinkDialogValidation(device) {
            this.device = device
            this.is_reset_device_battery_by_downlink_dialog_open = true
        },
    },
}
</script>
